module.exports = __webpack_public_path__ + "media/images/bengali-matrimony-canada-banner-709b71f81423dfafe70caa4c9747abe9.jpg";